import React, { FC } from 'react';
import styled from 'styled-components';

import { Link } from 'components/Common';
import SearchIcon from 'icons/search.svg';
import { isiOS } from 'config';
import fsc from 'fsc';

const SearchImg = styled.img`
  margin-right: 20px;
  vertical-align: ${isiOS ? 'sub' : 'middle'};
  height: 20px;
`;

interface SearchButtonProps {
}

export const SearchButton: FC<SearchButtonProps> = () => {
  return (
    <Link
      to={`/v2/search`}
      pageDirection="FORWARD"
      onClick={() =>
        fsc
          .view('Home')
          .Tapped('Search Button')
          .send()
      }
    >
      <SearchImg src={SearchIcon} alt="Search" aria-label="search-icon" id="search-icon" />
    </Link>
  );
};